import './ticket_response_view.js.coffee'
Customer.Dashboard ||= {}

class Customer.Dashboard.TicketEmailResponseView extends Customer.Dashboard.TicketResponseView
  template: JST['backbone/templates/customer/ticket/body/response_email']
  className: 'response-box-wrapper'

  events:
    'click #cancel': 'onCancel'
    'click .send_response': 'onClickReply'
    'click .send_response_and_close': 'onClickReplyAndClose'
    'click #predefined-answers-btn': 'showResponseTemplates'
    'click #expand-response-btn': 'onExpand'
    'click #reply': 'reply'
    'click #forward': 'forward'
    'click .send_response_and_change_to_pending': 'onClickReplyAndChangeToPending'

  render: =>
    @responseContainerId = UniqueId.generate()
    @renderTemplate()
    @expanded = false
    if @ticket.get('can_reply')
      @responseContainer = @$el.find("##{@responseContainerId}")
      @renderWithResponseBox()
      @reply()
      _.defer(@addFooter)
    @

  onClickReply: (event) =>
    if @_assertValidSocialAccount()
      super(event)

  onClickReplyAndClose: (event) =>
    if @_assertValidSocialAccount()
      super(event)

  onClickReplyAndChangeToPending: (event) =>
    if @_assertValidSocialAccount()
      super(event)

  _assertValidSocialAccount: =>
    socialAccountSelect = @$el.find('#social_accounts')
    socialAccountSelect.removeClass('validation_error')
    socialAccountID = parseInt(socialAccountSelect.val())
    unless socialAccountID
      socialAccountSelect.addClass('validation_error')
      showError(I18n.t("customer.dashboard.errors.email_from_not_selected"))
      return socialAccountID
    return socialAccountID

  onChangeSocialAccount: (event) =>
    socialAccountSelect = @$el.find('#social_accounts')
    if parseInt(socialAccountSelect.val())
      socialAccountSelect.removeClass('validation_error')

  onAttach: ->
    @renderWithResponseBox() if @ticket.get('can_reply')

  onDetach: ->
    @editor?.depose()

  onExpand: =>
    if @expanded
      $('.ql-editor').css('height', '')
      scrollTop = @$el[0].offsetTop
    else
      $('.ql-editor').height($('#nano-detail').height() - 120)
      scrollTop = @scrollTopBasedOnScrollheight()
    @expanded = !@expanded
    @scrollTo(scrollTop)

  scrollTo: (scrollTop) ->
    scrollable = $('.microscroll')
    scrollable.animate({scrollTop: scrollTop})

  renderWithResponseBox: ->
    @loadPredefinedTemplatesBtn()
    @editor = HtmlEditorView.create(@responseContainer, @_editorOptions())
    @listenTo(@editor, 'editor:htmltext:inserted', @moveTextCursorToBeginning)
    @listenTo(@editor, 'editor:htmltext:textChanged', @_keepCustomerSessionAlive)
    @editor.render()
    @setTextLimits()
    @_renderAttachmentContainer()
    @onPublic()
    @setCaretAtLastOfResponse()
    @

  _renderAttachmentContainer: ->
    @_renderAttachments()
    @listenTo @attachment, 'add:attachment', @_showAttachmentRow
    @listenTo @attachment, 'remove:attachment', @_hideAttachmentRow
    @_attachmentRowEl().find('label#add-direct-attachment-file-btn').hide()
    @_attachmentRowEl().find('.attachments-title').removeClass('hidden')
    @_hideAttachmentRow()

  _showAttachmentRow: =>
    @_attachmentRowEl().removeClass('hidden')

  _hideAttachmentRow: =>
    files = @attachment.allFiles()
    @_attachmentRowEl().addClass('hidden') if files.length == 0 && @attachment.hasEmptyExistingAttachments()

  _attachmentRowEl: ->
    @$el.find('.attachment-uploader')

  _editorOptions: ->
    if @editor != undefined
      text = @editor.getPlainHTML().replace(/<div>\s*&nbsp;\s*<\/div>/g, '<br>')
    else
      text = @responseText
    @setTextLimits()
    {
      text: text
      textLimit: @textLimit
    }

  onSendResponse: (event, operation, chained_action) =>
    @_keepCustomerSessionAlive()
    event.preventDefault()
    errors = @emailResponseDetails.validateAttributes()
    try
      @editor.update()
      @updateResponse()
    catch error
      @responseContainer.addClass('validation_error')
      errors.push(I18n.t('customer.dashboard.new_case.modal.attribute_error.response'))
    if errors.length > 0
      @_showValidationErrorSwal(errors)
      return false
    super(event, operation, chained_action)
    false

  updateResponse: =>
    # we are replacing <div>&nbsp;</div> to <br>, because @editor ignores empty <div's> and empty <p's>
    # <p> elements are automatically replaced to <div> elements by the @editor
    replace_regex = /<div>(&nbsp;)*<\/div>/g
    final_html_text = @editor.getPlainHTML().replace(replace_regex, '<br>').replace(/&nbsp;/g, " ")
    @responseText = final_html_text

  _doResponse: (response, action, chained_action) ->
    chained_action.respond_to_parent = @options.mainResponse
    responsePromise = @ticket.publicResponseWithCallback(
      @_paramsToResponse(response, chained_action, action),
      chained_action.callbacks
    )
    @_disableResponse()
    responsePromise

  checkAction: (action) ->
    true

  _interactionIdToRespondTo: (privacy) ->
    @responseTo

  _handleResponseStaleDialogue: ->
    @_enableResponse()

  _addExtraParams: (params) ->
    @_addEmailParams(params)

  _addEmailParams: (params) ->
    params.response_html = params.response
    params.response = @responseWithoutHTML(params.response)
    params.actions = [@action]
    params.to_email = @emailResponseDetails.getEmailTo()
    params.subject = @emailResponseDetails.getSubject()
    params.to_cc_email = @emailResponseDetails.getCC()
    params.to_cco_email = @emailResponseDetails.getCCo()
    attachments = if @attachment then @attachment.toJSON() else []
    if @action == 'forward'
      params.forward = true
      attachments = attachments.concat(@attachment.existingAttachments.map((attachment) -> attachment.file))
    params.attachments = JSON.stringify(attachments)

  focus: ->
    @editor.focus()
    @scrollToTextBox()

# When press Reply or Forward chage name of buttons to send message
# and collapse navbar.
  _changingByAction: (name1, name2) ->
    @$el.find('#navbarItems').collapse('hide')
    @$el.find('a.send_response').text(name1)
    @$el.find('a.send_response_and_close').text(name2)
    @$el.find('button.send_response_and_close').text(name2)

  _dateFormat: (interaction) ->
    date = interaction.created_at()
    Date.create(date).format('ddd, MMM DD, YYYY HH:mm a')

  reply: (event) ->
    @action = 'reply'
    interaction = @_getInteractionToResponse()
    reply_close_text = "#{I18n.t('customer.dashboard.conversations.details.response.reply_close')}"
    reply_text = "#{I18n.t('customer.dashboard.conversations.details.response.reply')}"
    @_changingByAction(reply_text, reply_close_text)
    @_clearAttachments()
    @_hideAttachmentRow()

    authorusername = interaction.getValue('authorusername')
    if @isBrandEmail(authorusername)
# mail que estoy contestando es de la marca hacia un usuario
      toEmail = interaction.getValue('to_email')
    else
# mail que estoy contestando es de un usuario hacia la marca
      toEmail = authorusername

    @emailResponseDetails.disableEmailTo()
    @emailResponseDetails.addEmailTo(toEmail)

    toEmails = interaction.getValue('recipient_addresses')
    ccEmails = interaction.getValue('cc_addresses')
    finalCcEmails = _.union(toEmails, ccEmails)
    finalCcEmails = _.uniq(finalCcEmails)

    preferredSocialAccount = _.find interaction.attributes.social_accounts, (socialAccount) -> socialAccount.is_preferred
    preferredEmail = preferredSocialAccount && preferredSocialAccount.email

    if preferredEmail?
      finalCcEmails = _.reject finalCcEmails, (email) -> email.toLowerCase() == preferredEmail.toLowerCase() 
    
    if toEmail?
      finalCcEmails = _.reject finalCcEmails, (email) -> email.toLowerCase() == toEmail.toLowerCase()

    @emailResponseDetails.addCcEmails(finalCcEmails.join(","))

    subject = interaction.getValue('subject')
    @emailResponseDetails.disableSubject() unless @options.email_multi_threadkey_enabled
    @emailResponseDetails.setSubject(subject)
    @_responseTextArea().removeClass('message_text_area')
    @addFooter() if @editor.editor?
    @moveTextCursorToBeginning() if @editor.editor?

  forward: (event) ->
    @action = 'forward'
    forward_close_text = "#{I18n.t('customer.dashboard.conversations.details.response.forward_close')}"
    forward_text = "#{I18n.t('customer.dashboard.conversations.details.response.forward')}"
    @_changingByAction(forward_text, forward_close_text)
    @emailResponseDetails.enableEmailTo()
    @emailResponseDetails.clearEmailTo()
    @emailResponseDetails.enableSubject()
    @addFooter()
    @_responseTextArea().addClass('message_text_area')
    @_clearAttachments()
    @_renderExistingAttachments()
    @_hideAttachmentRow()
    @moveTextCursorToBeginning()

  _clearAttachments: =>
    return unless @attachment
    @attachment.clearAllAttachments()

  _renderExistingAttachments: =>
    interaction = @_getInteractionToResponse()
    @_renderAttachments()
    @_attachmentRowEl().removeClass('hidden')
    @attachment.restoreDefaultAttachments(interaction, silent: true)
    attachments = @attachment.setDefaultExistingAttachments(@_getExistingAttachments(interaction))
    @attachment.createExistingFileLabel(attachment) for attachment in attachments
    @listenTo(@attachment, 'remove:existingAttachment', @_onRemoveExistingAttachment)

  _getExistingAttachments: (interaction) ->
    interactionValues = interaction.getValues()
    return interactionValues.attachments unless _.isEmpty(interactionValues.attachments)
    return JSON.parse(interactionValues.attachment).data if interactionValues.attachment
    []

  _onRemoveExistingAttachment: (file) =>
    interaction = @_getInteractionToResponse()
    attachments = @_getExistingAttachments(interaction)
    if file.id
      @_removeFromJsonAttachments(interaction, attachments, file)
    else
      @_removeFromAttachments(interaction, attachments, file)
    @attachment.removeFromExistingAttachments(file)
    @_hideAttachmentRow()

  _removeFromAttachments: (interaction, attachments, file) ->
    interactionData = Object.assign({}, interaction.get('data'))
    dataContent = Object.assign({}, interactionData.content)
    dataContent.attachments = _.filter attachments, (attachment) -> attachment.url != file.url
    interactionData.content = dataContent
    interaction.set('data', interactionData, silent: true)

  _removeFromJsonAttachments: (interaction, attachments, file) ->
    filteredAttachments = _.filter attachments, (attachment) -> attachment.id != file.id
    filteredJsonAttachments = {}
    filteredJsonAttachments.data = filteredAttachments
    interactionData = Object.assign({}, interaction.get('data'))
    dataContent = Object.assign({}, interactionData.content)
    dataContent.attachment = JSON.stringify(filteredJsonAttachments)
    interactionData.content = dataContent
    interaction.set('data', interactionData, silent: true)

  addFooter: =>
    try
      @updateResponse()
    catch error
      @responseText = ''
    capitalizedAction = @action[0].toUpperCase() + @action[1..-1].toLowerCase()
    if @_responseContainsFooter()
      plainHTML = @responseText.replace(
        /<div>----------\s(Reply|Forward)\smessage\s----------<\/div>/,
        "<div>---------- #{capitalizedAction} message ----------</div>"
      )
    else
      plainHTML = @responseText + @_footerText(capitalizedAction)
    @editor.setHTML(plainHTML)

  _responseContainsFooter: ->
    @responseText.match(/<div>----------\s(Reply|Forward)\smessage\s----------<\/div>/)

  _footerText: (actionText) ->
    interaction = @_getInteractionToResponse()
    text = interaction.getValue('text_html') || "<textarea>#{interaction.getValue('text')}</textarea>"
    """
    <br>
    <div>---------- #{actionText} message ----------</div>
    <div>
      <div>From: #{interaction.name()} #{interaction.getValue('authorusername')}</div>
      <div>Date: #{@_dateFormat(interaction)}</div>
      <div>Subject: #{interaction.getValue('subject')}</div>
      <div>To: #{interaction.getValue('to_email')}</div>
    </div>
    <br>
    <div>#{text}</div>

    """

  forwardRecipientsValid: (recipients) =>
    emailRegEx = new RegExp(/// ^([\w.+-]+)@([\w.-]+)\.([a-zA-Z.]{1,6})$ ///i)
    emailRegEx.test recipients

  hasParticipants: ->
    false

  isBrandEmail: (authorEmail) ->
    emailList = @options.socialAccounts.filter((socialAccount) -> socialAccount.provider == 'email')
                                      .map((socialAccount) -> socialAccount.email)
    authorEmail in emailList

  responseWithoutHTML: (html_text) ->
    tempDiv = document.createElement("div")
    tempDiv.innerHTML = html_text
    return tempDiv.textContent || tempDiv.innerText || ""

  canAddAttachments: () ->
    true

  canSendPictures: () ->
    false

  createResponseAttachment: ->
    @_renderAttachments()

  renderTemplate: ->
    paramsToRender = @_getParamsToRender()
    @emailResponseDetails = new Customer.Dashboard.EmailTextDetailsView(
      mainTextView: @,
      subjectLimit: @options.subjectLimit || 500,
      socialAccounts: paramsToRender.socialAccounts,
      validateSubject: false
    )
    @_createEmailExtraActionsView(paramsToRender.options.notes)
    params = $.extend({}, paramsToRender, {@responseContainerId})
    @$el.html(@template(params))
    @$el.find('.response-mail-detail').html(@emailResponseDetails.render().el)
    @$el.find('#email-response-extra-actions').html(@emailExtraActions.render().el)

  onToggleEmojis: =>
    @_responseTextArea().emojiPicker('toggle')
    container = @responseContainer[0].getBoundingClientRect()
    $('.emojiPicker').offset({top: container.top - 300, left: container.right - 280})
    false

  addSignature: =>
    @ticketView.getSignatures().signaturesFor(@getInteractionToResponseSubtype(), @getInteractionToResponseLabels(), (signature) =>
      if signature == ''
        @emailExtraActions.noSignatureTooltip()
      else
        @editor.insertHTMLTextAtCursor(signature)
    )

  addNote: ->
    @ticketView.openNoteModal()

  addAttachment: ->
    button = @$el.find('.attachment-uploader label#add-direct-attachment-file-btn')
    button.click()

  _createEmailExtraActionsView: (enabledNotes) ->
    @emailExtraActions = new Customer.Dashboard.EmailTextExtraActionsView(
      notes: enabledNotes,
      schedule: true
    )
    @listenTo(@emailExtraActions, 'email:action:add:note', @addNote)
    @listenTo(@emailExtraActions, 'email:action:add:signature', @addSignature)
    @listenTo(@emailExtraActions, 'email:action:add:attachment', @addAttachment)
    @listenTo(@emailExtraActions, 'email:action:schedule:response', @openResponseSchedule)


  _showValidationErrorSwal: (errors) ->
    error_text = "#{I18n.t('customer.dashboard.new_case.modal.validation_error')}:\n"
    _.each(errors, (error) =>
      error_text = error_text.concat "\n #{error}"
    )
    swal(
      I18n.t('customer.dashboard.new_case.modal.validation'),
      error_text,
      'error'
    )

  _responseTextArea: ->
    @editor.textareaElement()

  _renderSignature: (signature) ->
    @editor.insertTextAtCursor(signature)

  _getEmailTo: ->
    interaction = @ticket.get('dialogue').interactions[0]
    if @isBrandEmail(interaction.getValue('authorusername'))
      interaction.getValue('to_email')
    else
      interaction.getValue('authorusername')

  _socialAccounts: ->

  responseTemplateSelected: (text) ->
    @editor.insertHTMLTextAtCursor(text)

  moveTextCursorToBeginning: ->
    editor = document.querySelector('.ql-editor')
    editor.focus()
    firstLine = editor.firstChild
    range = document.createRange()
    range.setStart(firstLine, 0)
    range.setEnd(firstLine, 0)
    sel = window.getSelection()
    sel.removeAllRanges()
    sel.addRange(range)

  scrollToTextBox: ->
    scrollTop = @scrollTopBasedOnScrollheight()
    @scrollTo(scrollTop)

  scrollTopBasedOnScrollheight: ->
    @$el.find('.response-mail-detail')[0].offsetTop + @$el.find('.response-mail-detail')[0].scrollHeight

  _keepCustomerSessionAlive: ->
    Backbone.trigger 'customerSession:keepAlive'


  _getSocialAccounts: ->
    interaction = @_getInteractionToResponse()
    socialAccounts = interaction.get('social_accounts')
    enabledEmailSocialAccounts = @options.enabled_email_social_accounts
    return socialAccounts unless enabledEmailSocialAccounts.length != 0

    preferredAccount = _.findWhere(socialAccounts, {is_preferred: true} )
    if preferredAccount?
      enabledEmailSocialAccounts.forEach((account) ->
        account.is_preferred = account.id == preferredAccount.id
      )
    return enabledEmailSocialAccounts
